import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'
import { URL_CONST } from 'utils/urlConsts'

import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'
import { addToast } from 'containers/Toasts/actions'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../PartnerOptions/constants'

import AddMailboxEpic from './Management/AddMailbox/epics'
import { ADD_ASYNC, STATUSES_TOGGLE_ASYNC } from './Management/constants'
import managementEpics from './Management/epics'
import { STATUS_TOGGLE_ASYNC } from './Management/TableRow/constants'
import segmentsEpics from './Segments/epics'
import uploadEpics from './Upload/epics'
import userReportEpics from './UserReport/epics'
import {
  asGDCancel,
  asGDSuccess,
  asO365Cancel,
  asO365Success,
  fetchDataCancel,
  fetchDataSuccess,
  fetchSegmentsCancel,
  fetchSegmentsSuccess,
} from './actions'
import { AS_GD_ASYNC, AS_O365_ASYNC, DATA_REQUEST_ASYNC, SEGMENTS_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      STATUS_TOGGLE_ASYNC.SUCCESS,
      STATUSES_TOGGLE_ASYNC.SUCCESS,
      ADD_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.self) !== -1
      return true
    }),
    mergeMap(() => {
      const state = state$.value
      const companyFilter = selectCompanyFilter(state)?.value
      return api.mailboxes.getInfo(companyFilter).pipe(
        map((response) => fetchDataSuccess(response)),
        catchError((error) =>
          of(addToast({ message: error.response?.message, type: 'error' }), fetchDataCancel())
        ),
        takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
      )
    })
  )

const fetchSegmentsEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(SEGMENTS_REQUEST_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.self) !== -1
      return true
    }),
    mergeMap(() =>
      api.mailboxes.getSegments(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => fetchSegmentsSuccess(response)),
        catchError((error) =>
          of(addToast({ message: error.response?.message, type: 'error' }), fetchSegmentsCancel())
        ),
        takeUntil(action$.pipe(ofType(SEGMENTS_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const asO365Epic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(AS_O365_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .asO365(state$.value.partnerOptions.selectedCompany?.value, action.payload.body || {})
        .pipe(
          map((response) => asO365Success(response)),
          catchError((error) =>
            of(addToast({ message: error.response?.message, type: 'error' }), asO365Cancel())
          ),
          takeUntil(action$.pipe(ofType(AS_O365_ASYNC.CANCEL)))
        )
    )
  )

const asGDEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(AS_GD_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .asGD(state$.value.partnerOptions.selectedCompany?.value, action.payload.body || {})
        .pipe(
          map((response) => asGDSuccess(response)),
          catchError((error) =>
            of(addToast({ message: error.response?.message, type: 'error' }), asGDCancel())
          ),
          takeUntil(action$.pipe(ofType(AS_GD_ASYNC.CANCEL)))
        )
    )
  )

// Nesting these four local epics in their own inner `combineEpics(...)`
// would make them share ONE isolation budget and one crash label. Flattened
// so each gets its own. The remaining entries are genuine sub-barrels and
// each stays one leaf.
export default combineEpicsIsolated(
  fetchDataEpic,
  fetchSegmentsEpic,
  asO365Epic,
  asGDEpic,
  uploadEpics,
  managementEpics,
  segmentsEpics,
  AddMailboxEpic,
  userReportEpics
)
